import React from 'react';
import styled from 'styled-components/macro';

import FacebookShare from './FacebookShare';
import TwitterShare from './TwitterShare';
import MailShare from './MailShare';
import LinkedInShare from './LinkedInShare';

import { isPortrait } from '../../utils/size';

const ShareWrapper = styled.section`
    width: 100%;
    display: flex;
`;

const Container = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    display: flex;
    justify-content: ${() => (isPortrait() ? `flex-start` : `center`)};
    margin: 0 -5px;

    @media (max-width: 26em) {
        justify-content: space-around;
        margin: 0 25px;
    }

    > div,
    > a {
        width: 36px;
        height: 36px;
        margin: 0 5px;

        @media (max-width: 30em) {
            width: 52px;
            height: 52px;
        }

        > div,
        > a {
            width: 100%;
        }
    }
`;

const SocialShareGroup = props => (
    <ShareWrapper>
        <Container>
            <FacebookShare {...props} />
            <TwitterShare {...props} />
            <LinkedInShare {...props} />
            <MailShare {...props} />
        </Container>
    </ShareWrapper>
);

export default SocialShareGroup;
